import type { ReactNode } from "react";

export function AdminPanel({
  children,
  title,
  description,
}: {
  children: ReactNode;
  title?: string;
  description?: string;
}) {
  return (
    <section className="rounded-lg border border-line bg-field p-5 shadow-soft">
      {title ? (
        <div className="mb-5">
          <h2 className="text-lg font-semibold text-ink">{title}</h2>
          {description ? (
            <p className="mt-1 text-sm leading-6 text-graphite/65">
              {description}
            </p>
          ) : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
